// SPDX-License-Identifier: AGPL-3.0-or-later

import type {CosmeticItemResponse} from '@fluxer/schema/src/domains/cosmetics/CosmeticResponseSchemas';
import type {
	ShopBundleResponse,
	ShopPriceResponse,
	ShopUsernameCardResponse,
} from '@fluxer/schema/src/domains/shop/ShopResponseSchemas';

// Lifetime premium with a numbered badge; sold on the premium page, never in the shop tab.
export const VISIONARY_SKU = 'visionary';
// One boost slot for 30 days; sold from a community's boost page, never in the shop tab.
export const BOOST_SKU = 'boost:30';

export type ShopItemEntry = {kind: 'item'; sku: string; item: CosmeticItemResponse; price: ShopPriceResponse | null};
export type ShopPackageEntry = {kind: 'package'; sku: string; months: 1 | 3 | 12; price: ShopPriceResponse};
// A bundle carries its items: a bundle-only item has no price, so the items list does not have it.
export type ShopBundleEntry = {kind: 'bundle'; sku: string; bundle: ShopBundleResponse; price: ShopPriceResponse};
// A 1-3 character username, sold as the name itself: nothing is worn.
export type ShopUsernameCardEntry = {kind: 'username'} & ShopUsernameCardResponse;
// One named username on sale at its own price: priced and shown like its length's card, with the name fixed.
export type ShopUsernameProductEntry = ShopUsernameCardEntry & {username: string};
export type ShopEntry = ShopItemEntry | ShopPackageEntry | ShopBundleEntry | ShopUsernameCardEntry;

export function itemSku(itemId: string): string {
	return `cosmetic:${itemId}`;
}

export function packageSku(months: 1 | 3 | 12): string {
	return `premium:${months}`;
}

export function usernameSku(length: 1 | 2 | 3): string {
	return `username:${length}`;
}
